import React from "react";
import { ActionHandlerFunction } from "@preveil-api";
import { AdminUIActionTypes, useAppSelector } from "src/common";
import { Icon, ToolbarButton, ToolbarWrapper } from "src/components";
import { RootState } from "src/store/configureStore";

type AllProps = {
  is_loading: boolean;
  groups_aliases: string[];
  handleAction: ActionHandlerFunction;
}

// Description: Toolbar component for the User Groups list view. Actions include creating a new group, copying an existing group (only available when one group is selected),
// deleting selected groups, and refreshing the list. It also displays the count of groups currently available.
function ToolbarComponent(props: AllProps) {
  const { is_loading, groups_aliases, handleAction } = props;
  const selected = useAppSelector((state: RootState) => state.admin.selected);

  const count_label = groups_aliases.length > 0
    ? `${groups_aliases.length} ${groups_aliases.length > 1 ? "User Groups" : "User Group"}`
    : "";

  return <ToolbarWrapper
    paginationInfo={<span className="pagination_info">{count_label}</span>}
    refreshAction={() => handleAction({ actionType: AdminUIActionTypes.Refresh })}
    refreshTooltipContent="Refresh User Groups"
    isLoading={is_loading}
  >
    <ToolbarButton
      onClick={() => handleAction({ actionType: AdminUIActionTypes.ShowModal })}
      ariaLabel="Create User Group"
      tooltipContent="Create User Group">
      <Icon className="ficon-plus" />
    </ToolbarButton>
    <ToolbarButton
      disabled={selected.length !== 1}
      onClick={() => handleAction({ actionType: AdminUIActionTypes.Copy })}
      ariaLabel="Copy Selected"
      tooltipContent="Copy Selected">
      <Icon className="ficon-copy" />
    </ToolbarButton>
    <ToolbarButton
      disabled={selected.length === 0}
      onClick={() => handleAction({ actionType: AdminUIActionTypes.Delete })}
      ariaLabel="Delete Selected"
      tooltipContent="Delete Selected">
      <Icon className="ficon-trash-2" />
    </ToolbarButton>
  </ToolbarWrapper>;
}

export default React.memo(ToolbarComponent);
